import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid, TextField, Tooltip, ClickAwayListener } from '@material-ui/core'
import { isMobile } from 'react-device-detect';
import ButtonBase from '../../../components/Buttons/ButtonBase';
// import { states, cities, availablePeople } from '../../../utils/cities';
// import Select from '../../../components/SimpleSelect/Select'
// import MomentUtils from '@date-io/moment';
// import {DAYS} from '../../../utils/ConstantsMain'
// import ComboText from '../../../components/ComboText/';
// import {
//   MuiPickersUtilsProvider,
//   KeyboardTimePicker,
//   KeyboardDatePicker,
// } from '@material-ui/pickers';
import { connect } from 'react-redux';
import { openModalFree, closeModalFree } from "../../../store/actions/ModalFree";


const styles = () => ({
  TextField: {
    maxWidth: '536px',
  },
  realWidth: {
    '@media screen and (max-width: 400px)': {
      width: '90%'
    },
  },
  TextFieldTooltip: {
    maxWidth: '536px',
    margin: '0 10px 0 0',
  },
  TextField_small: {
    maxWidth: '144px',
    marginRight: '24px',
  },
  Grid: {
    marginTop: 24,
  },
  input_icon: { 
    maxWidth: 560,
  },
  keyboardTimePicker: {
    margin: '16px 0 -8px 0',
  },
  customTooltip: {
    backgroundColor: '#094565',
    margin: '4px 0 0',
    padding: 8,
    maxWidth: 216,
    lineHeight: 1.2,
  },
  tooltipParagraph: {
    margin: 0,
    fontSize: 14,
    '& b': {
      fontSize: 14,
      fontWeight: 'bold'
    }
  },
  tooltipImage: {
    margin: isMobile ? '10px 0 0 10px' : '10px 0 0 0',
  },
});
const ContactLawyer = props => {

  // const [selectedDateStart, setSelectedDateStart] = useState(null);
  // const [selectedDateEnd, setSelectedDateEnd] = useState(null);

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    isValid,
    isLawyer,
    classes,
    setFieldValue,
    openModalFree,
    authClient,
    openModalFreeData,
    membershipType
  } = props;

  // const handleDateChangeEnd =  (date ,value)=> {
  //   setFieldValue('dayEnd', value);
  // };

  // const handleDateChangeStart =  (date ,value) =>  {
  //   setFieldValue('dayStart', value);
  // };

  // const handleTagSelect = field => value => {
  //   setFieldValue(field, value);
  // };

  const [openPhone, setOpenPhone] = useState(false);

  const handleTooltipClosePhone = () => {
    setOpenPhone(false);
  };

  const handleTooltipOpenPhone = () => {
    setOpenPhone(true);
  };

  // const handleOnFocus = (e, num) => {
  //   // let elemento = document.getElementById("phone");
  //   // elemento.blur();

  //   // if (authClient.membership.type === "Free" ) {
  //   //   openModalFree(true, authClient.membership.type, authClient.role )
  //   //   console.log('entroe if focus open ', openModalFreeData);
  //   // } else if(authClient.membership.type === "Free"){
  //   //   console.log('entro en el else ');
  //   //   closeModalFree(false, '', '')
  //   // }
  // }

  // const handleOnBlurCustom = () => {
  //   // closeModalFree(false, '', '')
  //   // console.log('openModalFree blur  ',openModalFreeData);
  // }

  // console.log('openModalFree blur  ',openModalFreeData);
  return (
    <form>
      <Grid
        container
        direction="column"
        classes={{ root: classes.Grid }}
      >
        <Grid container direction="row">
          <Grid item xs classes={{ root: classes.input_icon }}>
            <TextField
              label="Número fijo"
              type="number"
              name='phone'
              variant="outlined"
              // onBlur={handleOnBlurCustom}
              onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
              inputProps={{ minLength: 10, maxLength: 10 }}
              onChange={handleChange}
              value={values.phone}
              helperText={touched.phone && errors.phone ? errors.phone : ''}
              error={touched.phone && errors.phone ? true : false}
              fullWidth
              classes={{ root: classes.TextFieldTooltip }}
            />
          </Grid>
          <Grid item>
            <div>
              {isMobile === true ?
                <ClickAwayListener onClickAway={handleTooltipClosePhone}>
                  <Tooltip
                    onClose={handleTooltipClosePhone}
                    open={openPhone}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    classes={{tooltip: classes.customTooltip}}
                    title={
                      <p className={classes.tooltipParagraph}>
                        El <b>número telefónico</b> agregado en este campo será <b>visible en tu perfil</b> para los clientes que deseen contactarte.
                      </p>
                    }
                    placement='left'
                  >
                    <img 
                      src="../../img/profile/ayuda.png"
                      alt="?"
                      onClick={handleTooltipOpenPhone}
                      className={classes.tooltipImage}
                    />
                  </Tooltip>
                </ClickAwayListener> :
                <Tooltip
                  classes={{tooltip: classes.customTooltip}}
                  title={
                    <p className={classes.tooltipParagraph}>
                      El <b>número telefónico</b> agregado en este campo será <b>visible en tu perfil</b> para los clientes que deseen contactarte.
                    </p>
                  }
                  placement='bottom'
                >
                  <img
                    src="../../img/profile/ayuda.png"
                    alt="?"
                    className={classes.tooltipImage}
                  />
                </Tooltip>
              }
            </div>
          </Grid>
        </Grid>

        <TextField
          label="Teléfono móvil"
          type="number"
          name='movil'
          variant="outlined"
          // onBlur={handleOnBlurCustom}
          onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
          inputProps={{ minLength: 10, maxLength: 10 }}
          onChange={handleChange}
          value={values.movil}
          helperText={touched.movil && errors.movil ? errors.movil : ''}
          error={touched.movil && errors.movil ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
          className={classes.realWidth}
        />

        <TextField
          label="Número Whatsapp (business)"
          type="text"
          name='whats'
          variant="outlined"
          // onBlur={handleOnBlurCustom}
          onInput={(e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') }}
          inputProps={{ minLength: 10, maxLength: 10 }}
          onChange={handleChange}
          value={values.whats}
          helperText={touched.whats && errors.whats ? errors.whats : ''}
          error={touched.whats && errors.whats ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
          className={classes.realWidth}
        />

        <TextField
          label="Correo eléctronico"
          type="text"
          name='email'
          variant="outlined"
          // onBlur={handleOnBlurCustom}
          onChange={handleChange}
          value={values.email}
          helperText={touched.email && errors.email ? errors.email : ''}
          error={touched.email && errors.email ? true : false}
          fullWidth
          classes={{ root: classes.TextFieldTooltip }}
          className={classes.realWidth}
        />
      </Grid>

      <TextField
        label="Sitio de Internet o blog"
        type="text"
        name='blog'
        variant="outlined"
        // onBlur={handleOnBlurCustom}
        onChange={handleChange}
        value={values.blog}
        helperText={touched.blog && errors.blog ? errors.blog : ''}
        error={touched.blog && errors.blog ? true : false}
        fullWidth
        classes={{ root: classes.TextField }}
        className={classes.realWidth}
      />

      <div className="horizontal-layout" style={{ marginTop: 15 }}>
        <ButtonBase
          type="submit"
          onClick={handleSubmit}
          variant="primary"
          disabled={!isValid}
          classes={{ root: classes.ButtonBase }}
        >
          Guardar cambios
        </ButtonBase>
      </div>
    </form>
  );
};

const mapDispatchToProps = dispatch => ({
  openModalFree: (open, typeMembership, role ) => dispatch(openModalFree(open, typeMembership, role )),
  closeModalFree: (open, typeMembership, role ) => dispatch(closeModalFree(open, typeMembership, role ))
})

const mapStateToProps = (state) => ({
  authClient: state.authClient,
  openModalFreeData: state.ModalFreeReducer.openModalFree,
  membershipType: state.authClient.membership.type
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContactLawyer));